/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  no-undef
*/
import React from 'react';
import createReactClass from 'create-react-class';
import { defineMessages, injectIntl } from 'react-intl';

require('./index.scss');

const messages = defineMessages({
  headertext: {
    id: 'signer.preview.esignDisclosure.headerText',
    description: 'text in signer flow, edisclosure for signer to click before signing',
    defaultMessage: 'I agree to $LINK$ by $BUSINESS_NAME$.',
  },
  headerLinkText: {
    id: 'signer.preview.esignDisclosure.headerLinkText',
    description: 'text in signer flow, edisclosure for signer to click before signing',
    defaultMessage: 'electronic records and signature agreement*',
  },
});
const EsignWrapper = createReactClass({
  getDefaultProps() {
    return {
      businessName: '',
    };
  },

  getInitialState() {
    return {
      checkboxChecked: false,
      checkboxDisabed: false,
    };
  },

  performAction() {
    if (!this.state.checkboxDisabed) {
      this.props.checkboxAction();
      this.setState({ checkboxChecked: true, checkboxDisabed: true });
    }
  },

  render() {
    const businessName = _.unescape(this.props.businessName);
    const headerTextArr = this.props.intl.formatMessage(messages.headertext).split('$LINK$');
    const headerTextLink = (
      <a href="#" onClick={this.props.linkAction}>{ this.props.intl.formatMessage(messages.headerLinkText) }</a>
    );
    const headerTextPrefix = headerTextArr[0].replace('$BUSINESS_NAME$', businessName);
    const headerTextSuffix = headerTextArr[1].replace('$BUSINESS_NAME$', businessName);
    return (
      <div className={this.props.className}>
        <label className="m-signature-request-preview--esign-wrapper-checkbox-container">
          { headerTextPrefix }{ headerTextLink }{ headerTextSuffix }
          <input
            className="m-signature-request-preview--esign-wrapper-checkbox"
            type="checkbox"
            disabled={this.state.checkboxDisabed}
            checked={this.state.checkboxChecked} />
          <span className="m-signature-request-preview--esign-wrapper-checkbox-checkmark" onClick={this.performAction}></span>
        </label>
      </div>
    );
  },
});

module.exports = injectIntl(EsignWrapper);
